import { render } from "./WizardModal.vue?vue&type=template&id=4a9929ba&scoped=true"
import script from "./WizardModal.vue?vue&type=script&lang=js"
export * from "./WizardModal.vue?vue&type=script&lang=js"

import "./WizardModal.vue?vue&type=style&index=0&id=4a9929ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dell\\Documents\\eChook\\Code\\gpt-nano-configurator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9929ba"]])

export default __exports__